import React from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { SettingsNavigation } from "@/navigation/stacks/SettingsStack";

import HelpCentralMobile from "./HelpCentral.mobile";
import HelpCentralWeb from "./HelpCentral.web";

const HelpCentral = () => {
  const { isWebMode } = useViewport();
  const { goBack } = useAppNavigation<SettingsNavigation>();

  const Screen = isWebMode ? HelpCentralWeb : HelpCentralMobile;

  return <Screen onBack={goBack} />;
};

export default HelpCentral;
